import { render } from "./HeaderButton.vue?vue&type=template&id=d1e403f4&lang=pug"
import script from "./HeaderButton.vue?vue&type=script&lang=js"
export * from "./HeaderButton.vue?vue&type=script&lang=js"

import "./HeaderButton.vue?vue&type=style&index=0&id=d1e403f4&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__